export enum EFiscalImportedDocumentType {
  Pdf = 1,
  Xml = 2,
}
